import "./button.css";

function Buttons() {
    return (
        <div className="button-container">
            <a href="#qualifications" className="btn pri">
                Learn more
            </a>
            
            <a href="https://drive.google.com/file/d/1YNDlLI6xA6NKjpbg-ojeUm70ZgexJG3X/view?usp=sharing" className="btn btm med" rel="noreferrer" target="_blank">
                CV
            </a>
            <a href="#contact" className="btn sec">
                Get In Touch
            </a>
        </div>
    );
}

export default Buttons;